<script setup lang="ts">
import CiSkeletonItem from '@/components/skeleton/CiSkeletonItem.vue';
</script>

<template>
  <div class="relative block overflow-hidden rounded-lg bg-white/60 md:h-[14.4375rem] xl:h-[17.25rem]">
    <div class="row no-gutters h-full">
      <div class="col-12 col-md-4 relative">
        <CiSkeletonItem class="h-full pt-[75%]" />
      </div>

      <div class="col-12 col-md-8 h-full">
        <div class="ml-0 h-full p-2 md:ml-2">
          <div class="row no-gutters h-full">
            <div class="col-12 col-md-8">
              <div class="flex h-full flex-col">
                <CiSkeletonItem class="mb-1 block h-5 w-3/5" />
                <CiSkeletonItem class="block h-[30px] w-[70%]" />

                <div class="mt-4 flex md:mt-auto">
                  <CiSkeletonItem class="size-12 rounded-full md:-ml-10" />
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="flex h-full flex-col justify-end">
                <CiSkeletonItem class="mt-4 block h-10 w-full rounded-[2.3444rem]" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style></style>
